import { ColumnType } from '../../../types';
import { ChartSettingsV2MenuItems, } from '../chart-settings-v2-schema.types';
import { createContentDensityRadioGroup, createDisplayAllSummaryCheckbox, createDisplayFooterCheckbox, createHeadlineConditionalFormatter, createTableColumnNumberFormatter, createTableConditionalFormatter, createTableSortFormat, createTableSummaryLabelledView, createTableSummaryNumberFormatter, createTextWrapToggle, createThemeSelectorDropdown, } from '../schema-composer-utils/common-elements';
import { createAccordion, createAccordionItem, createSection, createTableColumnRenameInput, } from '../schema-composer-utils/elements';
const columnSettings = [
    {
        type: undefined,
        settings: [
            createSection({
                children: [createDisplayAllSummaryCheckbox()],
            }),
        ],
    },
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                properties: {
                                    header: '',
                                    isExpanded: true,
                                    noPadding: true,
                                    variant: 'sideNav',
                                },
                                children: [
                                    createTableColumnRenameInput(),
                                    createTableColumnNumberFormatter(),
                                    createTableSortFormat(),
                                    createTableConditionalFormatter(),
                                    createTableSummaryLabelledView(),
                                    createTableSummaryNumberFormatter(),
                                    createHeadlineConditionalFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createTableColumnRenameInput(),
                                    createTableColumnNumberFormatter(),
                                    createTableConditionalFormatter(),
                                    createTableSummaryLabelledView(),
                                    createTableSummaryNumberFormatter(),
                                    createHeadlineConditionalFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        properties: {
                            spacing: 'ignore',
                        },
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createTableColumnRenameInput(),
                                    createTableSummaryLabelledView(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
];
const displaySettings = [
    createSection({
        children: [
            createThemeSelectorDropdown(),
            createContentDensityRadioGroup(),
            createTextWrapToggle(),
            createDisplayFooterCheckbox(),
        ],
    }),
];
export const tableSettingsSchema = {
    [ChartSettingsV2MenuItems.COLUMN]: columnSettings,
    [ChartSettingsV2MenuItems.AXIS]: null,
    [ChartSettingsV2MenuItems.DATA_LABEL]: null,
    [ChartSettingsV2MenuItems.TOOLTIP]: null,
    [ChartSettingsV2MenuItems.LEGEND]: null,
    [ChartSettingsV2MenuItems.DISPLAY]: displaySettings,
};
//# sourceMappingURL=table-schema.js.map